// import React from 'react';
// import {
//   Card,
//   Box,
//   Typography,
//   Button,
//   Badge,
//   useTheme,
//   alpha
// } from '@mui/material';
// import { tokens } from '../../theme/theme';


// const DashboardCard = ({
//   title,
//   icon,
//   onClick,
//   badge,
//   subtitle = 'View Details',
//   cardProps = {},
//   iconProps = {},
//   titleProps = {},
//   buttonProps = {}
// }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const secondary400 = colors.secondary?.[400] || theme.palette.secondary?.main || '#f50057';
//    const secondary500 = colors.secondary?.[500] || theme.palette.secondary?.main || '#64132f';
//    const secondary600 = colors.secondary?.[600] || theme.palette.secondary?.main || '#320314';
//   return (
//     <Card
//       elevation={3}
//       sx={{
//       //   backgroundColor: colors.primary[400],
//       //   borderRadius: 3,
//       //   p: 3,
//       //   textAlign: "center",
//       //   transition: "0.3s",
//       //   cursor: "pointer",
//       //   "&:hover": {
//       //     transform: "translateY(-5px)",
//       //     boxShadow: theme.shadows[6],
//       //   },
//       //   ...cardProps.sx
//       // }}
//       // onClick={onClick}
//       // {...cardProps}

//         backgroundColor: alpha(colors.primary[400], 0.15),
//         border: `1px solid ${alpha(colors.primary[400], 0.3)}`,
//         borderRadius: 2.5,
//         p: 2.5,
//         textAlign: "center",
//         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//         cursor: "pointer",
//         position: 'relative',
//         overflow: 'hidden',
//         minHeight: 140,
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
        
//         "&:before": {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           right: 0,
//           height: '2px',
//           background: `linear-gradient(90deg, ${colors.primary[400]}, ${colors.primary[500]})`,
//         },
        
//         "&:hover": {
//           backgroundColor: alpha(colors.primary[400], 0.25),
//           transform: "translateY(-8px)",
//           boxShadow: `0 12px 32px ${alpha(colors.primary[500], 0.3)}`,
//           borderColor: colors.primary[400],
//           "& .icon-container": {
//             backgroundColor: alpha(colors.primary[400], 0.3),
//             transform: 'scale(1.15) rotate(5deg)',
//             boxShadow: `0 8px 24px ${alpha(colors.primary[500], 0.4)}`,
//           },
//           "& .title-text": {
//             color: colors.primary[300],
//           }
//         },
//         ...cardProps.sx}}
//         onClick={onClick}
//       {...cardProps}
//     >
//       <Box className="icon-container"
//         sx={{
//            width: 64,
//           height: 64,
//           mx: "auto",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: alpha(colors.primary[400], 0.2),
//           borderRadius: "16px",
//           mb: 1.5,
//           border: `2px solid ${alpha(colors.primary[400], 0.3)}`,
//           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//           ...iconProps.sx
//         }}
//         {...iconProps}
//       >
//         {badge ? (
//           <Badge
//             badgeContent={badge}
//             color="error"
//             overlap="circular"
//             sx={{
//                "& .MuiBadge-badge": {
//                 fontSize: "9px",
//                 height: "14px",
//                 minWidth: "14px",
//                 padding: "0 3px",
//                 fontWeight: 700,
//                 border: `1px solid ${colors.grey[900]}`,
//               },
//             }}
//           >
//             {icon}
//           </Badge>
//         ) : (
//           icon
//         )}
//       </Box>

//       <Typography 
//         className="title-text"
//         variant="h6" 
//         fontWeight={700}
//         fontSize={16}
//         color={colors.grey[100]}
//         mb={1.5}
//         sx={titleProps.sx}
//         {...titleProps}
//       >
//         {title}
//       </Typography>

//       <Button
//         variant="contained"
//         // color="secondary"
//         size="small"
//        sx={{ 
//           mt: 'auto',
//           px: 2.5,
//           py: 0.75,
//           borderRadius: 2,
//           textTransform: 'none',
//           fontSize: '0.75rem',
//           fontWeight: 600,
//           background: `linear-gradient(135deg, ${secondary400} 0%, ${secondary500} 100%)`,
//           boxShadow: `0 4px 12px ${alpha(secondary500, 0.3)}`,
//           '&:hover': {
//             background: `linear-gradient(135deg, ${secondary500} 0%, ${secondary600} 100%)`,
//             boxShadow: `0 6px 20px ${alpha(secondary500, 0.4)}`,
//             transform: 'translateY(-2px)',
//           },
//           ...buttonProps.sx
//         }}
//         onClick={(e) => {
//           e.stopPropagation();
//           onClick?.(e);
//         }}
//         {...buttonProps}
//       >
//         {subtitle}
//       </Button>
//     </Card>
//   );
// };

// export default DashboardCard;


// import React from 'react';
// import {
//   Card,
//   Box,
//   Typography,
//   Button,
//   Badge,
//   useTheme,
//   alpha
// } from '@mui/material';
// import { tokens } from '../../theme/theme';


// const DashboardCard = ({
//   title,
//   icon,
//   onClick,
//   badge,
//   subtitle = 'View Details',
//   cardProps = {},
//   iconProps = {},
//   titleProps = {},
//   buttonProps = {}
// }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

  

//   return (
//     <Card
//       elevation={0}
//       sx={{
//         backgroundColor: alpha(colors.primary[400], 0.15),
//         border: `1px solid ${alpha(colors.primary[400], 0.3)}`,
//         borderRadius: 2.5,
//         p: 2.5,
//         textAlign: "center",
//         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//         cursor: "pointer",
//         position: 'relative',
//         overflow: 'hidden',
//         minHeight: 140,
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
        
//         "&:before": {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           right: 0,
//           height: '2px',
//           background: `linear-gradient(90deg, ${colors.primary[400]}, ${colors.primary[500]})`,
//         },
        
//         "&:hover": {
//           backgroundColor: alpha(colors.primary[400], 0.25),
//           transform: "translateY(-8px)",
//           boxShadow: `0 12px 32px ${alpha(colors.primary[500], 0.3)}`,
//           borderColor: colors.primary[400],
//           "& .icon-container": {
//             backgroundColor: alpha(colors.primary[400], 0.3),
//             transform: 'scale(1.15) rotate(5deg)',
//             boxShadow: `0 8px 24px ${alpha(colors.primary[500], 0.4)}`,
//           },
//           "& .title-text": {
//             color: colors.primary[300],
//           }
//         },
//         ...cardProps.sx
//       }}
//       onClick={onClick}
//       {...cardProps}
//     >
//       <Box className="icon-container"
//         sx={{
//           width: 64,
//           height: 64,
//           mx: "auto",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: alpha(colors.primary[400], 0.2),
//           borderRadius: "16px",
//           mb: 1.5,
//           border: `2px solid ${alpha(colors.primary[400], 0.3)}`,
//           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//           ...iconProps.sx
//         }}
//         {...iconProps}
//       >
//         {badge ? (
//           <Badge
//             badgeContent={badge}
//             color="error"
//             overlap="circular"
//             anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             sx={{
//               "& .MuiBadge-badge": {
//                 fontSize: "9px",
//                 height: "14px",
//                 minWidth: "14px",
//                 padding: "0 3px",
//                 fontWeight: 700,
//                 border: `1px solid ${colors.grey[900]}`,
//               },
//             }}
//           >
//             {icon}
//           </Badge>
//         ) : (
//           icon
//         )}
//       </Box>

//       <Typography 
//         className="title-text"
//         variant="h6" 
//         fontWeight={700}
//         fontSize={16}
//         color={colors.grey[100]}
//         mb={1.5}
//         sx={titleProps.sx}
//         {...titleProps}
//       >
//         {title}
//       </Typography>

//       <Button
//         variant="contained"
//         size="small"
//         sx={{ 
//           mt: 'auto',
//           px: 2.5,
//           py: 0.75,
//           borderRadius: 2,
//           textTransform: 'none',
//           fontSize: '0.75rem',
//           fontWeight: 600,
//           background: `linear-gradient(135deg, ${colors.secondary[400]} 0%, ${colors.secondary[500]} 100%)`,
//           boxShadow: `0 4px 12px ${alpha(colors.secondary[500], 0.3)}`,
//           '&:hover': {
//             background: `linear-gradient(135deg, ${colors.secondary[500]} 0%, ${colors.secondary[600]} 100%)`,
//             boxShadow: `0 6px 20px ${alpha(colors.secondary[500], 0.4)}`,
//             transform: 'translateY(-2px)',
//           },
//           ...buttonProps.sx
//         }}
//         onClick={(e) => {
//           e.stopPropagation();
//           onClick?.(e);
//         }}
//         {...buttonProps}
//       >
//         {subtitle}
//       </Button>
//     </Card>
//   );
// };

// export default DashboardCard;

import React from 'react';
import {
  Card,
  Box,
  Typography,
  Button,
  Badge,
  useTheme,
  alpha
} from '@mui/material';
import { tokens } from '../../theme/theme';

const DashboardCard = ({
  title,
  icon,
  onClick,
  badge,
  subtitle = 'View Details',
  colors: propColors, // Accept colors prop
  cardProps = {},
  iconProps = {},
  titleProps = {},
  buttonProps = {}
}) => {
  const theme = useTheme();
  
  // Safe color extraction with fallbacks
  const colors = propColors || tokens(theme.palette.mode === 'dark' ? 'dark' : 'light') || {};
  const primary400 = colors.primary?.[400] || theme.palette.primary?.main || '#1976d2';
  const primary500 = colors.primary?.[500] || theme.palette.primary?.dark || '#1565c0';
  const primary300 = colors.primary?.[300] || '#42a5f5';
  const grey100 = colors.grey?.[100] || '#f5f5f5';
  const grey900 = colors.grey?.[900] || '#121212';

  return (
    <Card
      elevation={0}
      sx={{
        backgroundColor: alpha(primary400, 0.15),
        border: `1px solid ${alpha(primary400, 0.3)}`,
        borderRadius: 2.5,
        p: 2.5,
        textAlign: "center",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        cursor: "pointer",
        position: 'relative',
        overflow: 'hidden',
        minHeight: 140,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        
        "&:before": {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          background: `linear-gradient(90deg, ${primary400}, ${primary500})`,
        },
        
        "&:hover": {
          backgroundColor: alpha(primary400, 0.25),
          transform: "translateY(-8px)",
          boxShadow: `0 12px 32px ${alpha(primary500, 0.3)}`,
          borderColor: primary400,
          "& .icon-container": {
            backgroundColor: alpha(primary400, 0.3),
            transform: 'scale(1.15) rotate(5deg)',
            boxShadow: `0 8px 24px ${alpha(primary500, 0.4)}`,
          },
          "& .title-text": {
            color: primary300,
          }
        },
        ...cardProps.sx
      }}
      onClick={onClick}
      {...cardProps}
    >
      <Box className="icon-container"
        sx={{
          width: 64,
          height: 64,
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: alpha(primary400, 0.2),
          borderRadius: "16px",
          mb: 1.5,
          border: `2px solid ${alpha(primary400, 0.3)}`,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          ...iconProps.sx
        }}
        {...iconProps}
      >
        {badge ? (
          <Badge
            badgeContent={badge}
            color="error"
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "9px",
                height: "14px",
                minWidth: "14px",
                padding: "0 3px",
                fontWeight: 700,
                border: `1px solid ${grey900}`,
              },
            }}
          >
            {icon}
          </Badge>
        ) : (
          icon
        )}
      </Box>

      <Typography 
        className="title-text"
        variant="h6" 
        fontWeight={700}
        fontSize={16}
        color={grey100}
        mb={1.5}
        sx={titleProps.sx}
        {...titleProps}
      >
        {title}
      </Typography>

      <Button
        variant="contained"
        size="small"
        sx={{ 
          mt: 'auto',
          px: 2.5,
          py: 0.75,
          borderRadius: 2,
          textTransform: 'none',
          fontSize: '0.75rem',
          fontWeight: 600,
          background: `linear-gradient(135deg, ${theme.palette.secondary?.main || '#f50057'} 0%, ${theme.palette.secondary?.dark || '#c51162'} 100%)`,
          color: 'white',
          boxShadow: `0 4px 12px ${alpha(theme.palette.secondary?.main || '#f50057', 0.3)}`,
          '&:hover': {
            background: `linear-gradient(135deg, ${theme.palette.secondary?.dark || '#c51162'} 0%, ${theme.palette.secondary?.main || '#f50057'} 100%)`,
            boxShadow: `0 6px 20px ${alpha(theme.palette.secondary?.main || '#f50057', 0.4)}`,
            transform: 'translateY(-2px)',
          },
          ...buttonProps.sx
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        {...buttonProps}
      >
        {subtitle}
      </Button>
    </Card>
  );
};

export default DashboardCard;
